export const USER_START = 'USER_START';
export const USER_SUCCESS = 'USER_SUCCESS';
export const USER_FAILURE = 'USER_FAILURE';
export const MAIL_START = 'MAIL_START';
export const MAIL_SUCCESS = 'MAIL_SUCCESS';
export const MAIL_FAILURE = 'MAIL_FAILURE';
export const NODE_START = 'NODE_START';
export const NODE_SUCCESS = 'NODE_SUCCESS';
export const NODE_FAILURE = 'NODE_FAILURE';
export const SYSTEM_SETTING_START = 'SYSTEM_SETTING_START';
export const SYSTEM_SETTING_SUCCESS = 'SYSTEM_SETTING_SUCCESS';
export const SYSTEM_SETTING_FAILURE = 'SYSTEM_SETTING_FAILURE';
export const ACCOUNT_INVENTORY_START = 'ACCOUNT_INVENTORY_START';
export const ACCOUNT_INVENTORY_SUCCESS = 'ACCOUNT_INVENTORY_SUCCESS';
export const ACCOUNT_INVENTORY_FAILURE = 'ACCOUNT_INVENTORY_FAILURE';

export const CSV_OUTPUT_START = 'CSV_OUTPUT_START';
export const CSV_OUTPUT_SUCCESS = 'CSV_OUTPUT_SUCCESS';
export const CSV_OUTPUT_FAILURE = 'CSV_OUTPUT_FAILURE';

export const CLEAR_ALL = 'CLEAR_ALL';

export const FATAL_FAILURE = 'SYSTEM_FAILURE';
